{
  "version": 1,
  "asset_id": "cee4ff73-9a8d-45f7-b391-b529c638a086",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cee4ff73-9a8d-45f7-b391-b529c638a086/lap-band-diagram-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cee4ff73-9a8d-45f7-b391-b529c638a086/lap-band-diagram-800.webp",
  "original_filename": "lap-band-diagram-800.webp",
  "size": 22710,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:13:00Z"
}
